
import React from "react"
import { useTranslation } from 'react-i18next';
import { Link } from "react-router-dom";
import UseScrollAnimation from "../../hooks/UseScrollAnimation";
export default function AboutUs() {
    const { t } = useTranslation();
    UseScrollAnimation();
    return (
        <>
            <section className="landingPages">
                <div className="container h-full flex flex-col gap-[10px] justify-center">
                    <div className="btmAni30002 text-[35px] font-bold text-white">{t("About us")}</div>
                    <div className="btmAni25002 flex items-center gap-[3px] text-white">
                        <Link to={"/"}>{t("Home")}</Link>
                        <span>-</span>
                        <div>{t("About us")}</div>
                    </div>
                </div>
            </section>
            <section className="relative py-[40px]">
                <div className="container flex flex-col gap-[20px]">
                    <div className="f-col gap-10 flex items-center ">
                        <div className="w-100 w-[100%] flex flex-col gap-[12px]">
                            <div className="js-scroll fade-right font-bold text-[25px] capitalize">{t("About AJ Mart")}</div>
                            <p className="js-scroll fade-left text-[14px] text-[#666666] capitalize">
                                {t("about one")}
                            </p>
                        </div>
                    </div>
                    <div className="f-col gap-10 flex items-center ">
                        <div className="w-100 w-[100%] flex flex-col gap-[12px]">
                            <div className="js-scroll fade-left font-bold text-[25px] capitalize">{t("our Mission")}</div>
                            <p className="js-scroll fade-right text-[14px] text-[#666666] capitalize">
                                {t("about two")}
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}